import EFOcats_answer from '../../../core/v2/answer/efocats_answer.js';

/**
 * 任意マーク設置
 */
export default class EFOcats_curves_answer_nini extends EFOcats_answer {
  /**
   * 回答欄設置
   */
  set(tmp, answer, elem) {
    let line = 0;

    if (answer.line) {
      line = answer.line;
    }

    elem.find('.cat-txt').eq(line).addClass('icon-nini');
    elem.find('.check-flag').eq(line).addClass('ok-flag');
  }
}
